<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h1>Platform / Button</h1>
  </div>
</div>

<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h2>Options</h2>
    <h3>Type</h3>
    <p>Type specifies the layout of the button <code>primary</code> (default), <code>secondary</code> or <code>hollow</code></p>
    <div class="button-row">
      <ui-platform-button
        label="Primary"
        [type]="'primary'">
      </ui-platform-button>
      <ui-platform-button
        label="Secondary"
        [type]="'secondary'">
      </ui-platform-button>
      <ui-platform-button
        label="Warn"
        [type]="'warn'">
      </ui-platform-button>
      <ui-platform-button
        label="Text"
        [type]="'text'">
      </ui-platform-button>
    </div>

    <h3>Disabled</h3>
    <div class="button-row mt-3">
      <ui-platform-button
        label="Primary"
        [disabled]="true"
        [type]="'primary'">
      </ui-platform-button>
      <ui-platform-button
        label="Secondary"
        [disabled]="true"
        [type]="'secondary'">
      </ui-platform-button>
      <ui-platform-button
        label="Warn"
        [disabled]="true"
        [type]="'warn'">
      </ui-platform-button>
      <ui-platform-button
        label="Text"
        [disabled]="true"
        [type]="'text'">
      </ui-platform-button>
    </div>

    <h3>Label</h3>
    <p>String used as a button label.</p>
    <p>When no label is provided, horizontal paddings are 0.5rem instead of 1rem</p>
    <div class="button-row">
      <ui-platform-button
        label="Primary"
        [type]="'primary'">
      </ui-platform-button>

      <ui-platform-button
        label="With icon"
        [icon]="'check'"
        [type]="'primary'">
      </ui-platform-button>

      <ui-platform-button
        [icon]="'check'"
        [type]="'primary'">
      </ui-platform-button>
    </div>
    <h3>Icon</h3>
    <p>If icon option is set button is displayed with a ui-icon. Icon option is of type UiIconList, so only custom library icons are supported right now.</p>
    <div class="button-row">
      <ui-platform-button
        label="Primary"
        [icon]="'check'"
        [type]="'primary'">
      </ui-platform-button>

      <ui-platform-button
        label="English (US)"
        [icon]="'translate'"
        [textSize]="'smaller'"
        [type]="'text'">
      </ui-platform-button>
    </div>

    <h3>Text size</h3>
    <p>By default, fontsize is 1rem. Set <code>textSize</code> to <code>smaller</code> font parameter to get 0.875rem font-size</p>
    <div class="button-row">
      <ui-platform-button
        label="Primary"
        [icon]="'arrow-up'"
        [type]="'text'">
      </ui-platform-button>

      <ui-platform-button
        label="English (US)"
        [icon]="'translate'"
        [textSize]="'smaller'"
        [type]="'text'">
      </ui-platform-button>
    </div>

    <h3>Icon placement</h3>
    <p>Icon placement control the placement of an icon inside of a button, available options are <code>left</code> (default), <code>right</code>.</p>
    <div class="button-row">
      <ui-platform-button
        label="Left"
        [icon]="'check'"
        [type]="'secondary'">
      </ui-platform-button>
      <ui-platform-button
        [icon]="'check'"
        [iconPlacement]="'right'"
        [label]="'Right'"
        [type]="'secondary'">
      </ui-platform-button>
    </div>

    <h3>In Progress</h3>
    <p>Set <code>inProgress</code> parameter to indicate in progress - for example when saving</p>
    <div class="button-row">
      <ui-platform-button
        label="In progress"
        [inProgress]="true"
        [type]="'primary'">
      </ui-platform-button>
    </div>

    <h3>Icon only</h3>
    <p>Provide icon and omit the label to display icon button</p>
    <div class="button-row">
      <ui-platform-button
        [icon]="'check'"
        [type]="'primary'">
      </ui-platform-button>
      <ui-platform-button
        [icon]="'lock'"
        [type]="'warn'">
      </ui-platform-button>
      <ui-platform-button
        [icon]="'arrow-up'"
        [type]="'secondary'">
      </ui-platform-button>
    </div>

    <h3>Lighter icon</h3>
    <p>Use Gray-3 for icon with lighterIcon parameter</p>
    <div class="button-row">
      <ui-platform-button
        [icon]="'dots'"
        [lighterIcon]="true"
        [type]="'text'">
      </ui-platform-button>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h2>Template usage</h2>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <h2>Code</h2>
    <p>Declare module:</p>
    <pre>{{ import }}</pre>
    <p>Use component in a template:</p>
    <pre>{{ usage }}</pre>
  </div>
</div>
